import { ArrowUpOutlined } from '@ant-design/icons';
import { Row } from 'antd';
import { toLower, upperFirst } from 'lodash';

import { MilesText, Status } from 'components';

import { getFormattedDate } from 'utils';

import { SnapDisplayComment } from 'codegen';

export const Comment = ({ comment }: { comment: SnapDisplayComment }) => {
  const commentTime = getFormattedDate(comment.createdAt, 'MMMM D, YYYY hh:mm A');

  const opsUserEmail = comment.opsUserEmail && `(${comment.opsUserEmail})`;

  return (
    <div className='px-[20px] py-[15px]'>
      <Row className='mb-2'>
        <MilesText
          size='sm'
          color='#707683'
        >
          {upperFirst(toLower(comment.opsUserRole))}
          {' '}
          ID
          {' '}
          {comment.opsUserId}
          {' '}
          {opsUserEmail}
          {' '}
          {commentTime}
        </MilesText>

        {comment.isEscalate && (
          <ArrowUpOutlined className='ml-2 text-[14px] text-[red]' />
        )}
      </Row>

      <Row>
        <MilesText size='md'>
          {comment.comment}
        </MilesText>
      </Row>

      <Row justify='end'>
        <Status status={comment.resolutionStatus} />
      </Row>
    </div>
  );
};
